<template>
  <div class="legal-modal-button">
    <LinkButton
      tag="button"
      type="button"
      class="legal-modal-button__button"
      :class="{ 'legal-modal-button__button--info': variant === 'info' }"
      :asterix="variant !== 'info'"
      :footnote="variant === 'info'"
      aria-label="Fußnote"
      @click="open"
    >
      <SvgIcon
        v-if="variant === 'info'"
        :image="InfoIcon"
        no-icon-class
        class="btn__icon"
      />
      <span v-else>*</span>
    </LinkButton>
  </div>
</template>

<script setup lang="ts">
import { LinkButton } from '@i22team/td-longtail-vue-components';
import InfoIcon from '~/assets/images/compatibility-list/info-icon.svg';
import { openModal } from '~/composables/modal';

export type LegalModalButtonProps = {
  texts: string[];
  variant?: 'default' | 'info';
};

const props = withDefaults(defineProps<LegalModalButtonProps>(), {
  variant: 'default',
});

const getText = computed(() => `<div>${props.texts.join('</div><div>')}</div>`);

const open = (e) => {
  e.preventDefault();
  e.stopPropagation();
  openModal({
    closeOnBackdrop: true,
    content: `<div class="unstyled-html">${getText.value}</div>`,
  });
};
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.legal-modal-button {
  display: inline-block;

  &__text {
    &:last-child p:last-of-type {
      margin-bottom: 0;
    }
  }

  &__button {
    &--info {
      --btn-padding: 0.2em 0.3em;
    }
  }
}
</style>
